export enum Role {
  CUSTOMER = 'role:customer',
}
